/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `supply` - Supply
* `distribution` - Distribution
 */
export type TypeC5bEnum = typeof TypeC5bEnum[keyof typeof TypeC5bEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TypeC5bEnum = {
  supply: 'supply',
  distribution: 'distribution',
} as const;
